import { useEffect } from 'react';
import Header from '../component/Header';
import { UniversityCover } from '../component/University/UniversityCover';

export const University = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
        <Header />
        <UniversityCover />
    </div>
  )
}
